import { createUseStyles } from 'react-jss';
import { CustomCiamUiTheme, label01 } from '../../../theme';

export default createUseStyles(
  {
    root: {
      maxWidth: '95%',
      textAlign: 'center',
      margin: 'auto',
      color: ({ theme }: { theme: CustomCiamUiTheme }) => theme.footerTextColor,
      ...label01,

      '& $link': {
        color: ({ theme }: { theme: CustomCiamUiTheme }) =>
          theme.footerLinkColor,
        textDecoration: 'underline',
      },
    },

    link: {
      color: ({ theme }: { theme: CustomCiamUiTheme }) => theme.footerLinkColor,
      textDecoration: 'underline',
    },
  },
  {
    name: 'Auth0Footer',
  },
);
